export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/windowsAccount/query`,
          data
        });
      },
      /**
       * 保存
       * @param data
       * @return {*}
       */
      save(data) {
          return http.json({
              url: '/windowsAccount/save',
              data
          })
      },
      /**
       * 获取详情
       * @param data
       * @return {*}
       */
      getInfo(data) {
          return http.json({
              url: `/windowsAccount/get?id=${data.id}`
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/windowsAccount.js